// extracted by mini-css-extract-plugin
export default {"controler":"controler_controler__m+HXs","redCircle":"controler_redCircle__aggZ+","blackCircle":"controler_blackCircle__WvVmx"};